var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmgTapRefill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8515_24754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 5.5104C8.68158 5.5104 6.81678 3.978 6.81678 2.778L6.81678 1.2C5.54598 2.0016 4.80078 2.6652 4.80078 5.5896L4.80078 17.5992C4.80078 22.08 8.92998 24 12.0008 24C15.0716 24 19.2008 22.08 19.2008 17.5992L19.2008 5.5896C19.2008 2.664 18.4556 2.0016 17.1848 1.2L17.1848 2.778C17.1848 3.978 15.32 5.5104 12.0008 5.5104ZM14.1548 8.7744C14.4548 8.9712 14.174 9.5856 14.174 9.5856L12.5684 13.134C12.5684 13.134 13.3724 13.4508 13.9376 13.6944C14.5028 13.9404 15.1424 14.1276 14.4272 15.1452C13.7096 16.164 10.5272 19.4424 10.5272 19.4424C10.5272 19.4424 10.1864 19.8564 9.86598 19.65C9.56358 19.4544 9.84678 18.8388 9.84678 18.8388L11.45 15.2916C11.45 15.2916 10.6484 14.9736 10.0832 14.73C9.51918 14.484 8.87598 14.2968 9.59358 13.2792C10.3088 12.2604 13.4936 8.9832 13.4936 8.9832C13.4936 8.9832 13.8332 8.5692 14.1548 8.7744ZM9.51438 1.3512L9.51438 2.25C9.51438 2.9208 10.4192 3.576 11.8892 3.576C13.3616 3.576 14.2652 2.9196 14.2652 2.25L14.2652 1.3512C14.2652 0.679199 13.3604 -3.74152e-07 11.8892 -3.09844e-07C10.418 -2.45536e-07 9.51438 0.679199 9.51438 1.3512Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8515_24754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 24) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmgTapRefill);
export default __webpack_public_path__ + "static/media/tmg_tap_refill.0099f302669d4a0569007e20d1d7dd45.svg";
export { ForwardRef as ReactComponent };